// Ordre des sections des pages publiques (réorganisable depuis l'admin)
export const PAGE_SECTIONS = {
  tournament: [
    { key: "stats", label: "Stats du tournoi" },
    { key: "standings", label: "Classements & matchs" },
    { key: "knockout", label: "Phases finales" },
    { key: "final_ranking", label: "Classement final" },
    { key: "videos", label: "Vidéos" },
    { key: "top_players", label: "Meilleurs joueurs" },
    { key: "team_awards", label: "Récompenses d'équipe" },
    { key: "gallery", label: "Photos" },
    { key: "sponsors", label: "Partenaires" },
  ],
  championship: [
    { key: "description", label: "Présentation" },
    { key: "stats", label: "Stats" },
    { key: "standings", label: "Classement" },
    { key: "teams", label: "Équipes" },
    { key: "players", label: "Joueurs" },
    { key: "awards", label: "Récompenses" },
    { key: "team_awards", label: "Récompenses d'équipe" },
    { key: "moments", label: "Moments forts" },
    { key: "videos", label: "Vidéos" },
    { key: "gallery", label: "Photos" },
    { key: "sponsors", label: "Partenaires" },
  ],
  team: [
    { key: "bio", label: "Présentation" },
    { key: "roster", label: "Effectif" },
    { key: "history", label: "Historique des tournois" },
    { key: "videos", label: "Vidéos" },
    { key: "achievements", label: "Palmarès" },
    { key: "gallery", label: "Photos" },
  ],
  player: [
    { key: "stats", label: "Stats" },
    { key: "videos", label: "Vidéos (highlights)" },
    { key: "profile", label: "Profil & infos" },
    { key: "race_results", label: "Résultats de course (pilotes)" },
    { key: "achievements", label: "Palmarès" },
    { key: "gallery", label: "Photos" },
  ],
};

// Ordre effectif : ordre sauvegardé complété par les sections manquantes (ordre par défaut)
export function orderedSections(page, saved) {
  const defaults = PAGE_SECTIONS[page].map((s) => s.key);
  const valid = (saved || []).filter((k) => defaults.includes(k));
  return [...valid, ...defaults.filter((k) => !valid.includes(k))];
}
